import axios from 'axios';
import store from '../index';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
const state = {
	pages: [],
	page: {},
	index: '',
	sortBy: '',
	sortDesc: '',
	pagesTree: [],
	pagesChildrean: [],
};

const getters = {
	getPages: state => {
		return state.pages;
	},
	getPage: state => {
		return state.page;
	},
	getIndex: state => {
		return state.index;
	},
	getSortBy: state => {
		return state.sortBy;
	},
	getSortDesc: state => {
		return state.sortDesc;
	},
	getPagesTree: state => {
		return state.pagesTree;
	},
	getPagesChildrean: state => {
		return state.pagesChildrean;
	},
};

const actions = {
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'pages';

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);
		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters['pages/getSortBy'],
						sortDesc: context.rootGetters['pages/getSortDesc'],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res.data.pagination);
				context.commit('setPages', res.data.data);
				return res.data.pagination;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
			});
	},

	deletePages: async (context, settings) => {
		let url = 'pages/delete';

		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						query: settings,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res.data.pagination);
				//context.commit('setCategories', res.data.data);
				return res.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err.response.status);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }*/
				return { error: err.response.status };
				//throw Error(err.response.status);
			});
	},
	getFetchNestedPage: async (context, payload) => {
		//console.log("parent",payload)
		let url = 'pages/nested';
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						parent: payload.parent,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res);
				//context.commit('setCategories', res.data.data);
				return { data: res.data, level: payload.level };
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
			});
	},
	setUpdateStatusPage: async (context, payload) => {
		//console.log("parent",payload)
		//console.log(payload)
		let url = 'pages/update/status';
		return await axios
			.put(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: payload,
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return { data: res.data, level: payload.level };
			})
			.catch(err => {
				console.log('errore', err);
			});
	},
	getFetchTreePage: async (context, payload) => {
		//console.log("parent",payload)
		let url = 'pages/lists';
		return await axios
			.get(
				`${context.rootGetters['settings/getUrl']}${url}`,

				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res);
				context.commit('setPagesTree', res.data.data);
				//return {data:res.data,level:payload.level}
				//resolve(res);
				return res.data.data;
			})

			.catch(err => {
				console.log('errore', err.response.status);
				if (err.response.status === 401) {
					//this.setLogout();
					context.commit('profile/setLogout', {}, { root: true });
					this.$router.push('/login');
				}
				throw Error(err.response.status + ':Posts Not Found');
			});
	},
	setupSort: async (context, payload) => {
		//console.log("parent",payload)
		let url = 'pages/setupsort';
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: payload.items,
					root: 2,
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return res;
				//context.commit('setCategoriesTree', res.data.data);
				//return res.data.data;
			})

			.catch(err => {
				console.log('errore', err);
			});
	},
	getDetailPage: async (context, payload) => {
		//console.log(payload)
		let url = `pages/detail/${payload.id}`;

		return await axios
			.get(
				`${context.rootGetters['settings/getUrl']}${url}`,

				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return { data: res.data };
			})
			.catch(err => {
				console.log('errore', err);
			});
	},
	getDetailParentPage: async (context, payload) => {
		//console.log(payload)
		let url = `pages/detailparent/${payload.id}`;

		return await axios
			.get(
				`${context.rootGetters['settings/getUrl']}${url}`,

				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return { data: res.data };
			})
			.catch(err => {
				console.log('errore', err);
			});
	},
	getNestedPage: async (context, payload) => {
		let url = 'pages/listschildrean';
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: payload,
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				context.commit('setCategoriesChildrean', res.data.data);
			})

			.catch(err => {
				console.log('errore', err);
			});
	},

	destroyData: context => {
		context.commit('setPages', []);
		context.commit('setPage', []);
		context.commit('setIndex', '');
		context.commit('setPagesTree', []);
		context.commit('setPagesChildrean', []);
	},
};

const mutations = {
	setPages: (state, value) => {
		state.pages = value;
	},
	setPage: (state, value) => {
		state.page = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
	setPagesTree: (state, value) => {
		state.pagesTree = value;
	},
	setPagesChildrean: (state, value) => {
		state.pagesChildrean = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
